import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const IncomeShape = ({ width = 45, height = 45, style }: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 1024 1024"
    className="icon"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <path
      d="M512 512m-480 0a480 480 0 1 0 960 0 480 480 0 1 0-960 0Z"
      fill="#62d44d"
    />
    <path
      d="M537.6 352m-102.4 0a102.4 102.4 0 1 0 204.8 0 102.4 102.4 0 1 0-204.8 0Z"
      fill="#fff"
    />
    <path
      d="M697.6 793.6h-12.8c-12.8 0-25.6-32-38.4-57.6-12.8 6.4-44.8 12.8-83.2 12.8h-25.6c-38.4-6.4-64-6.4-76.8-6.4 0 12.8-6.4 32-25.6 44.8-6.4 6.4-19.2 6.4-32 6.4s-32-6.4-38.4-6.4c-6.4 0-6.4-6.4-6.4-12.8v-64c0-25.6-12.8-32-12.8-32-89.6-38.4-128-96-134.4-140.8-6.4-25.6-6.4-38.4 0-44.8 6.4-6.4 12.8-6.4 19.2-6.4h6.4c12.8 0 38.4-6.4 44.8-25.6 6.4-19.2 19.2-25.6 25.6-32h6.4v-12.8c0-25.6-6.4-44.8-12.8-51.2v-12.8c0-6.4 12.8-6.4 19.2-6.4 44.8 6.4 76.8 32 89.6 38.4 44.8-25.6 89.6-38.4 140.8-38.4 32 0 70.4 0 121.6 19.2 147.2 51.2 134.4 179.2 134.4 185.6 0 44.8-25.6 83.2-44.8 108.8-12.8 19.2-19.2 57.6-25.6 83.2 0 6.4 0 19.2-6.4 25.6 6.4 19.2-6.4 25.6-32 25.6zM345.6 499.2c-6.4 0-12.8 6.4-12.8 12.8s6.4 19.2 19.2 19.2 12.8-6.4 12.8-19.2-6.4-12.8-19.2-12.8z"
      fill="#DEFCF9"
    />
  </svg>
);

export default IncomeShape;
